<template>
    <v-app>
              <iframe class="iframe"  :src="'http://121.78.147.57:8000/Eple_Web/Record.action?call_date='+callDate+'&phone_number='+phoneNo+'&company_code=ueducation'" frameborder="0"></iframe>


    </v-app>
</template>
<script>
export default {
    props:['callDate',"phoneNo"]
}
</script>